/**
* 基础菜单 商品管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>售后管理</el-breadcrumb-item>
        <el-breadcrumb-item>售后地址管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <div class="address">
      <div class="ment flex_box ">
        <p class="text f20 fontWeight">售后地址管理</p>
        <el-row>
          <el-button type="primary" plain size="mini" @click="edit">编辑</el-button>
        </el-row>
      </div>

      <div class="mt20">
        <el-descriptions class="margin-top" title="" :column="1" border>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 70px">收件人</div>
            </template>
            {{tableData.contact_name}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 70px">联系方式</div>
            </template>
            {{tableData.tel}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 70px">地址</div>
            </template>
            {{tableData.send_addr}}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="编辑地址"
               :visible.sync="editDialogVisible"
               width="30%"
               center>
      <el-form label-width="120px" :model="addressForm" :rules="rules" ref="addressForm" class="addressForm">
        <el-form-item label="收件人" prop="contact_name">
          <el-input size="small" v-model="addressForm.contact_name" placeholder="请输入收件人" clearable maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="tel">
          <el-input size="small" v-model="addressForm.tel" placeholder="请输入联系方式" clearable maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="send_addr">
          <el-input type="textarea" v-model="addressForm.send_addr" class="textarea" placeholder="请输入地址" maxLength="50" clearable
                    :rows="6"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">关 闭</el-button>
            <el-button type="primary" @click="sure('addressForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
  import {
    addressDetail, updateAddress
  } from '../../api/basisMG'

  export default {
    data: () => {
      return {
        loading: false, //是显示加载
        editDialogVisible: false, //控制页面显示与隐藏
        tableData:{
          id:'',
          contact_name:'',
          tel:'',
          send_addr:''
        },
        addressForm:{
          id:'',
          contact_name:'',
          tel:'',
          send_addr:''
        },
        // rules表单验证
        rules: {
          contact_name: [
            {required: true, message: '请输入收件人', trigger: 'blur'}
          ],
          tel: [{required: true, message: '请输入联系方式', trigger: 'blur'}],
          send_addr: [{required: true, message: '请输入地址', trigger: 'blur'}],
        },
      }
    },
    // 注册组件
    components: {
    },

    /**
     * 创建完毕
     */
    created() {
        this.getdata()
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        addressDetail()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.tableData = res.content;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      edit() {
        this.editDialogVisible =true;
        this.addressForm = this.tableData
      },
      sure(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            updateAddress(this.addressForm)
              .then(res => {
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '保存成功!'
                  });
                  this.editDialogVisible =false;
                  this.getdata()
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.order_code == cell.innerText || row.mobile == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
    }
  }
</script>


<style scoped>
  .contianer {
    height: calc(100% - 60px);
    background: #fff;
    padding: 20px;
    border-radius: 8px;
  }

  /deep/ .textarea .el-textarea__inner {
    height: 120px;
    width: 320px;
    resize: none;
  }

  /deep/ .addressForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }
  /deep/ .addressForm .el-input--small {
    width: 320px;
  }

   .mt20 {
     margin-top: 20px;
   }

  .f20 {
    font-size: 20px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .flex_box {
    display: flex;
  }

  .flex_box {
    display: flex;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 300px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .copy {
    width: 20px;
    height: 20px;
  }

  .copy img {
    width: 20px;
    height: 20px;
  }

  .saleTitle {
    color: #333333;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
    margin-top: 25px;
  }

  .picTitle {
    color: #333333;
    font-size: 15px;
    font-weight: 400;
    margin: 20px 0;
  }

  /deep/ .delivery .el-form-item {
    margin-left: 25%;
  }
  .breadcrumb {
    margin-bottom: 15px;
  }

  .address {
    width: 500px;
    height: 168px;
    margin: 30px 0 0 36px;
  }
  .ment {
    padding: 2px 12px;
    justify-content: space-between;
  }
  .text {
    font-family: 'PingFang SC';
    font-style: normal;
    line-height: 28px;
    color: #409EFF;
  }

</style>





// WEBPACK FOOTER //
// src/views/aftersale/AftersaleAddress.vue